"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartColumn = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const style_map_js_1 = require("lit/directives/style-map.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common/text/text");
/**
 * 범주별 몫을 세로 막대 높이로 그리는 차트.
 * 한 시리즈를 범주로 나눈 것이므로 막대마다 색을 나누지 않고 하나의 색을 쓴다.
 * selectable이면 각 열이 버튼이 되고, 고른 값은 change로 알리되 쓰임새는 소비처가 정한다.
 */
let ChartColumn = class ChartColumn extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.items = [];
        this.selectable = false;
        this.selected = '';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'list');
    }
    render() {
        return (0, lit_1.html) `
      ${this.items.map(item => this.renderColumn(item))}
    `;
    }
    renderColumn(item) {
        return (0, lit_1.html) `
      <div class="column" role="listitem">${this.renderContent(item)}</div>
    `;
    }
    renderContent(item) {
        if (!this.selectable) {
            return (0, lit_1.html) `
        <div class="content">${this.renderBody(item)}</div>
      `;
        }
        return (0, lit_1.html) `
      <button
        class="content"
        aria-pressed=${this.selected === item.label}
        @click=${() => this.handleColumnClick(item.label)}
      >
        ${this.renderBody(item)}
      </button>
    `;
    }
    renderBody({ label, share, value }) {
        return (0, lit_1.html) `
      ${value
            ? (0, lit_1.html) `
            <mm-text size="12">${value}</mm-text>
          `
            : lit_1.nothing}
      <div class="track">
        <div class="bar" style=${(0, style_map_js_1.styleMap)({ height: `${share}%` })}></div>
      </div>
      <mm-text size="12">${label}</mm-text>
    `;
    }
    handleColumnClick(label) {
        this.selected = this.selected === label ? '' : label;
        (0, utils_1.emit)(this, 'change', { value: this.selected });
    }
};
ChartColumn.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        --chart-column-height: var(--size-80);
        --chart-column-color: var(--background-strong-color);

        display: flex;
        gap: var(--space-2);
      }

      /* 열 너비는 컨테이너를 고르게 나눠 갖는다. 축의 폭은 차트가 놓인 자리가 정한다. */
      .column {
        display: flex;
        flex: 1;
        min-width: 0;
      }

      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--space-1);
        width: 100%;
      }

      button.content {
        cursor: pointer;
      }

      button.content:focus-visible {
        ${shared_styles_1.focusRingStyles};
      }

      .track {
        display: flex;
        align-items: flex-end;
        width: 100%;
        height: var(--chart-column-height);
        border-radius: var(--radius);
        background: var(--background-subtle-color);
      }

      button.content:hover .track {
        background: var(--interaction-hover-background-color);
      }

      button.content[aria-pressed='true'] .track {
        background: var(--interaction-selected-background-color);
      }

      .bar {
        width: 100%;
        border-radius: var(--radius);
        background: var(--chart-column-color);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], ChartColumn.prototype, "items", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], ChartColumn.prototype, "selectable", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChartColumn.prototype, "selected", void 0);
ChartColumn = __decorate([
    (0, decorators_js_1.customElement)('mm-chart-column')
], ChartColumn);
exports.ChartColumn = ChartColumn;
//# sourceMappingURL=data:application/json;base64,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